import styled from 'styled-components';
import { IdCheckButton, Input } from '../Join.style';

export const RegistrationNumberInput = styled(Input)`
    width: 72.08333333333333%;
`;

export const CertificationButton = styled(IdCheckButton)`
    padding: 17px 0;
    width: 25.41666666666667%;
`;
